import { connect } from 'react-redux';

import * as Profile from 'app/entities/Profile';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import MaybeRedirectOnMount from 'app/common/components/MaybeRedirectOnMount';
import PreloadPage from 'app/developer-v3/components/PreloadPage';
import hocify from 'app/common/components/hocify';

import Developer from './Developer';

const mapStateToProps = state => ({
  isLoading: Profile.selectors.all.isLoadImpending(state),
  redirectUrl: `/developer`,
  shouldRedirect: false,
});

const mapDispatchToProps = dispatch => ({
  onLoad() {
    dispatch(Profile.actions.loadCollection());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  hocify(LoadingBlockOrComponent, { LoadingComponent: PreloadPage })(
    hocify(MaybeRedirectOnMount)(Developer)
  )
);
